// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"47976e25","84":"bdd77720","201":"a341fb77","277":"8c1d2fba","279":"d02b1f0f","553":"24151e90","643":"9e7d1989","649":"4807f0ab","661":"4440f133","752":"e0c0c8ef","787":"5a6ea39a","791":"09c06c0a","867":"02c31e56","898":"30f7b5d9","955":"238565e5"}[chunkId] + ".chunk.js";
};